import type { HeaderAction, NavItem, UserMenuItem } from "@repo/dashboard-core";

// CUSTOMIZE: Define sidebar navigation items per business
export const navItems: NavItem[] = [
  { icon: "dashboard", labelKey: "nav.my-top-ups", href: "/" },
  { icon: "book", labelKey: "nav.library", href: "/library" },
  {
    icon: "globe",
    labelKey: "nav.international-calls",
    href: "/international-calls",
  },
  { icon: "esim", labelKey: "nav.esim", href: "/esim" },
  { icon: "sms", labelKey: "nav.send-sms", href: "/send-sms" },
  {
    icon: "phoneCheck",
    labelKey: "nav.phone-checker",
    href: "/phone-checker",
  },
  { icon: "piggyBank", labelKey: "nav.earn-back", href: "/earn-back" },
];

/** GD-98 — an eSIM customer's home reads "My dashboard"; every other item, the
 * separate Esim service included, stays as it is. */
export const esimNavItems: NavItem[] = navItems.map((item) =>
  item.href === "/" ? { ...item, labelKey: "nav.my-dashboard" } : item,
);

// CUSTOMIZE: Define header action buttons per business
export const headerActions: HeaderAction[] = [
  { icon: "messages", href: "/messages", labelKey: "nav.messages" },
  { icon: "questionCircle", href: "/faq", labelKey: "nav.faq" },
  { icon: "phone", href: "/contact", labelKey: "nav.contact" },
];

// CUSTOMIZE: Define user dropdown menu items per business
export const userMenuItems: UserMenuItem[] = [
  { icon: "user", labelKey: "user-menu.my-profile", href: "/profile" },
  { icon: "signOut", labelKey: "user-menu.log-out", danger: true },
];
